/* 🔑 공용 원자 — 두 스킨(`_skins/*`)이 같이 씁니다. 스킨 고유의 모양은 여기 두지 않습니다 (`docs/base/11` §5-2). */
/*
 * 브랜드 마크 — «티켓세상» (오너 지시 2026-09-13).
 *
 * 🔴 **알약·그라디언트·AI 느낌을 쓰지 않습니다.** 상품권/티켓을 단순 기하로
 *    나타냅니다 — 굵은 「T」 획 하나와, 그 왼쪽에 찢는 선(perforation, 점선)을
 *    두어 "표 한 장" 을 읽게 합니다. 16~20px 로 줄어도 획이 뭉개지지 않도록
 *    글자 하나·선 하나로만 이뤄져 있습니다.
 *
 * 🔴 **배경을 그리지 않습니다.** `currentColor` 로만 그려서, 이미 색이 있는
 *    칩(헤더의 흰 칩·푸터의 남색 칩) 안에 그대로 넣을 수 있습니다. 자체
 *    배경이 필요한 자리(파비콘 등)는 정적 SVG 파일
 *    (`apps/web/public/favicon.svg` · `apps/web/public/images/logo-mark.svg` ·
 *    `apps/mall/public/icon.svg` · `apps/mall/public/apple-icon.png`)에 같은 모양을 그려
 *    뒀습니다 — 그 파일들과 이 컴포넌트는 **같은 기하를 공유합니다**. 하나를 고치면 전부 고치세요.
 */
export function BrandMark({ className = "size-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
      <path d="M8 6v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="0.5 3.6" opacity="0.55" />
      <path d="M11 7h9M15.5 7v10" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}
